import { api } from "@/api";
import { invalidateStorageQueries, type StorageBooking } from "./storage";

/** Without an end date the server renews for a year from the current end
 *  (or from today, if that is later). Texts the welcome message again. */
export const renewStorageBooking = async (
  bookingId: string,
  endDate?: string,
) => {
  const { body } = await api.post<StorageBooking>(
    `/storage/bookings/${bookingId}/renew`,
    { body: endDate ? { endDate } : {} },
  );
  invalidateStorageQueries();
  return body;
};
